

export const makeChartData = (monthlySpend: number, cryptoPerformance: number, earnRate: number) => {
  let prevValue = 0
  return new Array(60).fill(0).map(() => {
    const monthlyEarn = monthlySpend * earnRate
    const result = monthlyEarn + prevValue * (1 + cryptoPerformance)
    prevValue = result

    return result
  }, 0)
}
